import { render, staticRenderFns } from "./PortadaSelectPreview.vue?vue&type=template&id=f2ad22ac"
import script from "./PortadaSelectPreview.vue?vue&type=script&lang=js"
export * from "./PortadaSelectPreview.vue?vue&type=script&lang=js"
import style0 from "./PortadaSelectPreview.vue?vue&type=style&index=0&id=f2ad22ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports